// VITE HMR
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Swiper } from "swiper";
import { Scrollbar } from "swiper/modules";
import LazyLoad from "vanilla-lazyload";
import "../scss/main.scss";
import { App } from "./App";
import { Accordion } from "./Components/Accordion";
import { AccordionGroup } from "./Components/AccordionGroup";
import { AjaxNavigation } from "./Components/AjaxNavigation";
import { AjaxPagination } from "./Components/AjaxPagination";
import { Clipboard } from "./Components/Clipboard";
import { CookieBanner } from "./Components/CookieBanner";
import { Dialog } from "./Components/Dialog";
import { ExpandingInput } from "./Components/ExpandingInput";
import { FetchUrl } from "./Components/FetchUrl";
import { FormComponent } from "./Components/FormComponent";
import { FrontPageSwiper } from "./Components/FrontPageSwiper";
import { InputSuffix } from "./Components/InputSuffix";
import { Login } from "./Components/Login";
import { EditProfileForm } from "./Components/MemberArea/EditProfileForm";
import { InvitationsTable } from "./Components/MemberArea/InvitationsTable";
import { MemberArea } from "./Components/MemberArea/MemberArea";
import { MembersTable } from "./Components/MemberArea/MembersTable";
import { Monthpicker } from "./Components/Monthpicker";
import { PageLoader } from "./Components/Navigation/PageLoader";
import { NewsPage } from "./Components/NewsPage";
import { Notifications } from "./Components/Notifications";
import { PageHeader } from "./Components/PageHeader";
import { PinForm } from "./Components/PinForm";
import { RepeatInput } from "./Components/RepeatInput";
import { Scroll } from "./Components/Scroll";
import { ScrollAnimations } from "./Components/ScrollAnimations";
import { Services } from "./Components/Services";
import { Share } from "./Components/Share";
import { SiteHeader } from "./Components/SiteHeader";
import { SwiperComponent } from "./Components/Swiper";
import { TextSwiper } from "./Components/TextSwiper";
import { EventPage } from "./Pages/EventPage";
import { EventsPage } from "./Pages/EventsPage";
import { FrontPage } from "./Pages/FrontPage";
import { createLogger } from "./util/logger";
import {CommunityCard} from "./Components/MemberArea/CommunityCard.js";
import {Register} from "./Components/Register.js";
const console = createLogger("main");

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

if (!window.listenerMap) {
  window.listenerMap = new Map();
}

Swiper.use([Scrollbar]);

// Fix for adblocker bug
console.log("test");
console.log("test");
console.log("test");

const original = EventTarget.prototype.addEventListener;
EventTarget.prototype.addEventListener = function (event, listener, options) {
  listenerMap.set(this, [
    ...(listenerMap.get(this) || []),
    [event, listener, options],
  ]);

  return original.call(this, event, listener, options);
};

if (import.meta.hot) {
  import.meta.hot.accept();

  if (window.app) {
    window.console.clear();
    window.app.destroy();
  }

  for (const [element, value] of window.listenerMap.entries()) {
    value.forEach((args) => {
      element.removeEventListener(...args);
    });
  }

  console.clear();
  ScrollTrigger.update();
}

console.log("ScrollTrigger", ScrollTrigger);

// LazyLoad instance
window.lazyload = new LazyLoad({
  elements_selector: "[data-lazy],[data-bg]",
  data_src: "lazy",
  restore_on_error: true,
  callback_loaded: (el, instance) => {
    ScrollTrigger.update();
  },
});

window.app = new App([
  // Form
  FormComponent,
  ExpandingInput,
  InputSuffix,
  RepeatInput,
  Monthpicker,

  // UI
  AccordionGroup,
  Accordion,
  SwiperComponent,
  TextSwiper,
  SiteHeader,
  Scroll,
  PageHeader,
  CookieBanner,
  Dialog,

    // Navigation
    FetchUrl,
    AjaxNavigation,
    AjaxPagination,
    PageLoader,
    Services,
    Login,
    Register,
    Share,
    EventsPage,
    EventPage,
    FrontPage,
    Notifications,

    // Member Area
    EditProfileForm,
    InvitationsTable,
    MembersTable,
    MemberArea,
    NewsPage,
    PinForm,
    Clipboard,
    CommunityCard,

    // Has to be last because of priority
    ScrollAnimations,
    FrontPageSwiper,


]);

document.body.classList.add("initialized");
